import { getTheme, mergeThemes, ThemeProvider as FluentThemeProvider } from '@fluentui/react';
import { FCWithChildren, useContext } from 'react';
import { DefaultTheme, ThemeProvider as TypelessStyledThemeProvider } from 'styled-components';
import { AppTheme, darkTheme, defaultTheme } from '../styles/themes';
import { nameof } from '../utils/stringUtils';
import { SettingsContext } from './SettingsProvider';

// fix for styled-components not being updated for React 18 usage
const StyledThemeProvider = TypelessStyledThemeProvider as unknown as FCWithChildren<{ theme: DefaultTheme | ((theme: DefaultTheme) => DefaultTheme) }>;

const baseTheme = getTheme();

const ThemeProvider: FCWithChildren = ({ children }) => {
    const { settings: { isDarkModeEnabled } } = useContext(SettingsContext);
    const theme = mergeThemes(baseTheme, isDarkModeEnabled ? darkTheme : defaultTheme) as AppTheme;

    return (
        <FluentThemeProvider theme={theme}>
            <StyledThemeProvider theme={theme}>
                {children}
            </StyledThemeProvider>
        </FluentThemeProvider>
    );
};

ThemeProvider.displayName = nameof({ ThemeProvider });
export default ThemeProvider;